import {
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { get, invoke } from 'lodash';

import { Async, IFieldPreferences } from '@shared/types';
import { XVISchemaFormGroupComponent } from '../../form/schema-form-group/schema-form-group.component';
import { asObservable } from '@shared/utils';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: 'xux-panel-group',
  templateUrl: 'xux-panel-group.component.html',
  styleUrls: ['xux-panel-group.component.scss'],
  // Notice: It is not possible to just switch this component to OnPush without breaking a big part of the app
})
export class XuxPanelGroupComponent implements OnChanges {
  @Input() public field: IFieldPreferences = {};
  @ViewChild(XVISchemaFormGroupComponent, { static: false })
  public xviPanelGroup: any;

  public titleObs: Async<string>;
  public descriptionObs: Async<string | TemplateRef<any>>;

  public focus(): void {
    invoke(this, 'xviPanelGroup.focus');
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  public ngOnChanges(changes: SimpleChanges): void {
    this.titleObs = get(this.field, 'titleObs', asObservable(this.field.title));
    this.descriptionObs = get(
      this.field,
      'descriptionObs',
      asObservable(this.field.description),
    );
  }
}
